import { render, staticRenderFns } from "./BrandAndSeriesCategoriesSelect.vue?vue&type=template&id=32cdb99f"
import script from "./BrandAndSeriesCategoriesSelect.vue?vue&type=script&lang=js"
export * from "./BrandAndSeriesCategoriesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports